import type { SupportedLocale } from './resources';

export const localeFlagEmoji: Record<SupportedLocale, string> = {
  en: '🇬🇧',
  es: '🇪🇸',
  zh: '🇨🇳',
};
